/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespComponents_searchBrowse$ref = any;
type SbRespComponents_user$ref = any;
type SbRespComponents_viewer$ref = any;
type SbSharedHead_searchBrowse$ref = any;
type SbSharedRefetchContainer_regionalInfo$ref = any;
type SbSharedRefetchContainer_searchBrowse$ref = any;
type SbSharedTrackingContainer_searchBrowse$ref = any;
type SbSharedTrackingContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespLayout_viewer$ref: FragmentReference;
export type SbRespLayout_viewer = {|
  +searchBrowse?: ?{|
    +$fragmentRefs: SbSharedRefetchContainer_searchBrowse$ref & SbRespComponents_searchBrowse$ref & SbSharedHead_searchBrowse$ref & SbSharedTrackingContainer_searchBrowse$ref
  |},
  +user?: ?{|
    +$fragmentRefs: SbSharedTrackingContainer_user$ref & SbRespComponents_user$ref
  |},
  +regionalInfo?: ?$ReadOnlyArray<?{|
    +$fragmentRefs: SbSharedRefetchContainer_regionalInfo$ref
  |}>,
  +$fragmentRefs: SbRespComponents_viewer$ref,
  +$refType: SbRespLayout_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "fetchSb",
      "type": "Boolean",
      "defaultValue": true
    },
    {
      "kind": "LocalArgument",
      "name": "hasPersonalizedFilter",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userZipCode",
      "type": "String",
      "defaultValue": "0"
    },
    {
      "kind": "RootArgument",
      "name": "uriRef",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "first",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "page",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "localeOrigin",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "eligibleAbTest",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespComponents_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasPersonalizedFilter",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "regionalInfo",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "zipCode",
              "variableName": "userZipCode",
              "type": "String"
            }
          ],
          "concreteType": "RegionalInfo",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedRefetchContainer_regionalInfo",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedTrackingContainer_user",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbRespComponents_user",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchSb",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "searchBrowse",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "eligibleAbTest",
              "variableName": "eligibleAbTest",
              "type": "String"
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "first",
              "type": "Int"
            },
            {
              "kind": "Variable",
              "name": "localeOrigin",
              "variableName": "localeOrigin",
              "type": "String"
            },
            {
              "kind": "Variable",
              "name": "page",
              "variableName": "page",
              "type": "Int"
            },
            {
              "kind": "Variable",
              "name": "uriRef",
              "variableName": "uriRef",
              "type": "String"
            }
          ],
          "concreteType": "SearchBrowseQueryConnection",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedRefetchContainer_searchBrowse",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbRespComponents_searchBrowse",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbSharedHead_searchBrowse",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbSharedTrackingContainer_searchBrowse",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '57ef1d6564a74a8686809ef242195c75';
module.exports = node;
